module.exports = __webpack_public_path__ + "img/thumbnail_Bonobo_m_normal.808471cf.png";